<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read test process'">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col>
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr></b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Name</b-th>
                  <b-td class="w-100">{{ test_process.name }}</b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Description</b-th>
                  <b-td class="w-100">{{ test_process.description }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/${test_process_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="test_process"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="test_process"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import { TestWorkflowRoutes } from '@/router/lab/TestWorkflowRoutes'
import TestProcessModel from '@/models/lab/TestProcessModel'

export default {
  name: "WorkflowTestProcessAuditTrail",
  components: {
    PermissionAlertGate,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      test_process: null,
      test_process_id: this.$route.params.test_process_id || null,
      sample_type_id: this.$route.params.sample_type_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.test_process_id}`,
            title: "View test process",
            variant: "info",
          }
        ]
      }
    },

    route_root () {
      return TestWorkflowRoutes.fetchRoot()
    }
  },
  async created () {
    this.loading = true

    this.test_process = new TestProcessModel({ id: this.test_process_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.test_process.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
